import Carousel from "react-multi-carousel";
import { Container, Row, Col } from "react-bootstrap";
import "react-multi-carousel/lib/styles.css";
import img1 from "../assets/img/cannon.webp";
import img2 from "../assets/img/camara_analoga.webp";
import img3 from "../assets/img/video_camara.webp";
import img4 from "../assets/img/drone.webp";
import img5 from "../assets/img/polaroid.webp";
import img6 from "../assets/img/luces.webp";

export const Features = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="features" id="equipment">
      <Container>
        <Row>
          <Col>
            <div className="features-bx">
              <h2>Equipment</h2>
              <h3>State-of-the-Art Tools for Precision and Perfection</h3>
              <p>
                {" "}
                From high-resolution cameras to top-tier lighting and
                post-production software, I use industry-leading equipment to
                ensure every shot is crisp, clean, and perfectly executed. My
                gear empowers me to bring creative ideas to life with unmatched
                clarity and detail.
              </p>
              <Carousel
                responsive={responsive}
                infinite={true}
                className="skill-slider"
              >
                <div className="item">
                  <img src={img1} alt="Image" className="feature-img"></img>
                  <h5>Digital Camera</h5>
                </div>
                <div className="item">
                  <img src={img2} alt="Image" className="feature-img"></img>
                  <h5>Analogue Camera</h5>
                </div>
                <div className="item">
                  <img src={img3} alt="Image" className="feature-img"></img>
                  <h5>Video Camera</h5>
                </div>
                <div className="item">
                  <img src={img4} alt="Image" className="feature-img"></img>
                  <h5>Drone</h5>
                </div>
                <div className="item">
                  <img src={img5} alt="Image" className="feature-img"></img>
                  <h5>Polaroid Camera</h5>
                </div>
                <div className="item">
                  <img src={img6} alt="Image" className="feature-img"></img>
                  <h5>Lightning</h5>
                </div>
              </Carousel>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
